<!--添加/编辑充电桩 form表单-->
<template>
    <v-card :color="theme.elementBgColor">
        <v-card-title>
            {{ form.id ? form.name : "添加充电桩" }}
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="mt-3">
            <el-form :model="form" label-width="6em" label-position="top">
                <el-form-item label="站点" :rules="[{ required: true }]">
                    <select-site
                        ref="selectSite"
                        :selectSite="form.station_id"
                        @choose="chooseSite"
                        :width="'60%'"
                    />
                </el-form-item>
                <!-- <el-form-item label="互联互通">
                    <select-cec :width="'60%'" :cecId="form.cec_id" @chooseCec="chooseCec" />
                </el-form-item> -->
                <el-form-item label="设备名称" :rules="[{ required: true }]">
                    <el-input v-model="form.name" autocomplete="off" style="width: 60%">
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="设备编码" :rules="[{ required: true }]">
                    <el-input
                        v-model="form.cec_equipment_id"
                        autocomplete="off"
                        @input="inputSerial"
                        style="width: 60%"
                    >
                        <i class="el-icon-edit" slot="prepend"></i>
                        <template v-if="isHave" slot="append">
                            此设备编号已存在
                        </template>
                    </el-input>
                </el-form-item>
                <el-form-item label="额定功率" :rules="[{ required: true }]">
                    <el-input v-model="form.power" autocomplete="off" style="width: 30%">
                        <i class="el-icon-edit" slot="prepend"></i>
                    </el-input>
                </el-form-item>
                <el-form-item label="设备类型" :rules="[{ required: true }]">
                    <el-radio
                        v-for="(item, index) in typeText"
                        :key="index"
                        v-model="form.type"
                        :label="item.id"
                    >
                        {{ item.value }}
                    </el-radio>
                </el-form-item>
            </el-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="dialog-footer d-flex justify-space-around pb-5">
            <v-btn width="30%" @click="cancel()" class="float-left">取消</v-btn>
            <v-btn width="30%" color="primary" @click="determine()" class="float-right">
                确定
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import util from "@/util";
import Public from "@/public"
import SelectSite from "@/components/SelectSite";
import SelectPile from "@/components/SelectPile";
import SelectCec from "@/components/SelectCec";
import { mapState } from "vuex";
import store from "@/store";
export default {
    data() {
        return {
            form: {
                id: null,
                name: null,
                cec_equipment_id: null,
                cec_id: null,
                power: null,
                station_id: null,
                type: null,
            },
            equipmentIdArray: null, //选中站点下的设备序列号数组
            equipmentData: null,
            isHave: false, //是否存在相同的设备编号
            typeText: [
                {
                    id: 1,
                    value: "直流设备",
                },
                {
                    id: 2,
                    value: "交流设备",
                },
                {
                    id: 3,
                    value: "交直流一体设备",
                },
                {
                    id: 4,
                    value: "无线",
                },
                {
                    id: 5,
                    value: "其他",
                },
            ],
            oldEquipmentId: null, //未修改的充电桩编码
        };
    },
    watch: {
        "form.cec_equipment_id": {
            handler(val) {
                if (!val) {
                    this.isHave = false;
                }
            },
            deep: true,
        },
        equipmentData: {
            handler(val) {
                if (val) {
                    Object.keys(this.form).forEach(key => {
                        this.form[key] = val[key];
                    });
                }
            },
            deep: true,
        },
        equipmentInfo: {
            handler(val) {
                this.equipmentIdArray = [];
                for (let i = 0; i < val.length; i++) {
                    this.equipmentIdArray.push(val[i].cec_equipment_id);
                }
            },
        },
        station_id: {
            handler(val) {
                if (val) {
                    this.form["station_id"] = val;
                }
            },
            deep: true,
        },
    },
    props: {
        isAdd: Boolean,
        isEdit: Boolean,
        passData: Object,
        station_id: Number,
    },
    updated() {
        this.$refs.selectSite.site = this.form["station_id"];
    },
    async mounted() {
        if (this.isEdit) {
            Object.keys(this.form).forEach(key => {
                this.form[key] = this.passData[key];
            });
            this.oldEquipmentId = this.form["cec_equipment_id"];
        }
        if (this.isAdd && this.station_id) {
            this.form["station_id"] = this.station_id;
        }
        this.getEquipmentInfo();
    },
    components: {
        SelectSite,
        SelectPile,
        SelectCec,
    },
    computed: {
        ...mapState(["equipmentInfo", "contactInfo", "TipType", "theme"]),
    },
    methods: {
        chooseCec(cecId) {
            this.form["cec_id"] = cecId;
        },
        async chooseSite(site) {
            if (site.cecId) {
                this.form["cec_id"] = site.cecId;
            }
            this.form["station_id"] = site.siteId;
            let postData = {
                station_id: site.siteId,
            };
            await store.dispatch("getEquipment", postData);
        },
        /*获取充电桩数据 用户判断是否存在相同的充电桩编号*/
        async getEquipmentInfo() {
            let postData = {
                station_id: this.form["station_id"],
            };
            await store.dispatch("getEquipment", postData);
            this.equipmentIdArray = [];
            for (let i = 0; i < this.equipmentInfo.length; i++) {
                this.equipmentIdArray.push(this.equipmentInfo[i].cec_equipment_id);
            }
        },
        /*确定添加或者修改设备*/
        async determine() {
            let params = {
                postData: { equipment: {} },
                callback: () => {
                    this.$emit("refresh");
                    this.cancel();
                },
            };
            let form = Object.assign({}, this.form);
            if (this.isAdd) {
                delete form.id;
            }
            delete form.cec_id;
            let nullKeyArr = Object.keys(form).filter(key => !form[key]);
            if (nullKeyArr.length == 0) {
                Object.keys(this.form).forEach(key => {
                    if (key == "name" || key == "cec_equipment_id") {
                        this.form[key] = Public.removeSpace(this.form[key]);
                    }
                    if (key == "type" || key == "power") {
                        params.postData.equipment[key] = Number(this.form[key]);
                    } else if (key == "cec_id") {
                        if (!this.form["cec_id"]) {
                            delete this.form["cec_id"];
                        } else {
                            params.postData.equipment["cec_id"] = this.form["cec_id"];
                        }
                    } else {
                        params.postData.equipment[key] = this.form[key];
                    }
                });
            } else {
                let utilText = "";
                for (let i1 = 0; i1 < nullKeyArr.length; i1++) {
                    if (i1 == nullKeyArr.length - 1) {
                        utilText = utilText + this.utilText(nullKeyArr[i1]);
                    } else {
                        utilText = utilText + this.utilText(nullKeyArr[i1]) + "、";
                    }
                }
                util.ShowTip(utilText + "不能为空", 3);
                return;
            }
            if (this.isAdd) {
                await store.dispatch("addEquipment", params);
            }
            if (this.isEdit) {
                await store.dispatch("updateEquipment", params);
            }
        },
        /*返回相应为空值指的文本*/
        utilText(key) {
            let text = "";
            if (!this.form[key]) {
                if (key == "station_id") {
                    text = "站点";
                }
                if (key == "power") {
                    text = "额定功率";
                }
                if (key == "type") {
                    text = "设备类型";
                }
                if (key == "name") {
                    text = "设备名称";
                }
                if (key == "cec_equipment_id") {
                    text = "设备编码";
                }
            }
            return text;
        },
        /*取消添加或修改设备*/
        cancel() {
            Object.keys(this.form).forEach(key => {
                if (key != "station_id") {
                    this.form[key] = null;
                }
            });
            this.$refs.selectSite.site = null;
            this.equipmentData = null;
            this.$emit("cancel");
        },
        inputSerial(e) {
            this.isHave = false;
            if (e.length > 0 && this.equipmentIdArray) {
                for (let i = 0; i < this.equipmentIdArray.length; i++) {
                    if (e.replace(/(^\s*)|(\s*$)/g, "") == this.equipmentIdArray[i]) {
                        this.isHave = true;
                    }
                }
            }
            if (this.oldEquipmentId == e) {
                this.isHave = false;
            }
        },
        trim(str) {
            return str.replace(/(^\s*)|(\s*$)/g, "");
        },
    },
};
</script>
